module.exports = __webpack_public_path__ + "media/images/photos/construction-223f943331731369e4916abefbee3e19.png";